// extracted by mini-css-extract-plugin
export default {"followers":"FollowersList_followers__u+54f","followersListContainer":"FollowersList_followersListContainer__Px0fC"};